import { FC } from "react";
import { useUpdateBanner } from "../model/useUpdateBanner";

/**
 * Tells the user a newer build is deployed and lets them take it now. No dismiss: the update
 * applies on its own at the next navigation (or on resume in an installed app) anyway.
 */
export const UpdateBanner: FC = () => {
  const { updateAvailable, isSaving, reload } = useUpdateBanner();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="mx-4 mt-4 flex items-center gap-3 rounded-xl border border-[#C9D8EE] bg-[#E6F0FB] px-4 py-3"
    >
      <img src="/icons/icon-192.png" alt="" className="h-10 w-10 shrink-0 rounded-lg" />
      <div className="min-w-0 flex-1">
        <p className="text-[15px] font-bold leading-tight text-[#124093]">Neue Version verfügbar</p>
        <p className="text-[14px] leading-tight text-[#4A5C74]">
          Neu laden, um die aktuelle Version zu nutzen.
        </p>
      </div>
      <button
        type="button"
        onClick={reload}
        disabled={isSaving}
        className="shrink-0 rounded-lg bg-[#124093] px-4 py-2 text-[15px] font-bold text-white disabled:opacity-60"
      >
        {isSaving ? "Wird gespeichert…" : "Jetzt aktualisieren"}
      </button>
    </div>
  );
};
